import React, { useState, useContext, useEffect } from 'react'
import LoginHandler from 'components/layouts/LoginHandler'
import { useDocumentTitle } from '../../components/hooks/useDocumentTitle'
import { useTranslation } from 'react-i18next'
import { LoggedInContext } from 'contexts/isLoggedIn'
import { useLocation } from "react-router-dom";
import { UseEmailContext } from 'contexts/userEmail'
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom'


const Start = () => {
  const { t } = useTranslation()
  const [isLoggedIn, setIsLoggedIn] = useContext(LoggedInContext)

  useDocumentTitle(t('start.page_title'))
  
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const email = queryParams.get("email");
  const token = queryParams.get("token");
  const [userEmail, setUserEmail] = useContext(UseEmailContext)
  const history = useHistory()
  
if (email && token ) {
  setUserEmail(email)
  setIsLoggedIn(true)
  window.localStorage.setItem('h', token)
  window.localStorage.setItem('e', email)
  Cookies.set('e', email, {
    domain: '.intego.com',
    sameSite: 'Strict',
    expires: 365
  })
  window.sessionStorage.removeItem('a')
  history.push('/welcome')
}

  return (
    <div className="page--start">
      <div className="logo"></div>
      <div className="card-warpper-row">
        <LoginHandler
          title={'landingFlow.page_1_title'}
          subTitle={'landingFlow.page_1_subtitle'}
          inputs={['email']}
          cta={t('forgot.continue')}
          action={'check-email'}
        />
      </div>
    </div>
  )
}

export default Start
